<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        <div class = "button-row">
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH')" />
            <Button label="저장" icon="pi pi-save" class="p-button-success mr-2" @click="btnAct('SAVE')" :disabled="!selectedItems || !selectedItems.length" />
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)"  />
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)"  />
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                    <div class="p-field-0 p-float-label m-2">
                        <div class="p-inputgroup">
                            <InputText id="calcYm" v-model.trim="searchParams.calcYm" type="text" style="width: 8rem" @keydown.enter="btnDialog('CodeHelpDialog', searchParams.calcYm)" />
                            <label for="calcYm">평가년도</label>
                            <Button icon="pi pi-search" class="p-button-search" @click="btnDialog('CodeHelpDialog', searchParams.calcYm)" />
                        </div>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <InputText id="calcCnt" type="text" v-model="searchParams.calcCnt" disabled style="width: 8rem"/>
                        <label for="calcCnt">평가차수</label>
                    </div>
                    <div class="p-field p-float-label m-auto" style="width: 8rem">
                        <Calendar v-model="searchParams.fromDate" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" />
                        <label>시작일자</label>
                    </div>
                    <div class="p-field p-float-label m-auto mr-2" style="width: 1rem">
                        <label>~</label>
                    </div>
                    <div class="p-field p-float-label m-auto" style="width: 8rem">
                        <Calendar v-model="searchParams.toDate" :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar style="width: 8rem" />
                        <label>종료일자</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="corpId" v-model="searchParams.corpId" :options="corps" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem" scrollHeight="20em" :editable="true"/>
                        <label for="corpId">업체명</label>
                    </div>
                </div> 
            </template>

            <template #end>
                
            </template>
        </Toolbar>

        <DataTable id="dt" ref="dt" :value="dataList" v-model:selection="selectedItems" :loading="loading"
            rowGroupMode="subheader" groupRowsBy="corpNm" class="p-datatable-sm" 
            editMode="cell" @cell-edit-complete="onCellEditComplete" 
            sortMode="single" sortField="corpNm" :sortOrder="1" scrollable scrollHeight="79vh">
            <Column header="No" style="min-width:3em; max-width:3em" exportFooter=" ">
                <template #body="{index}">
                    {{ index + 1 }}
                </template>    
            </Column>
            <Column selectionMode="multiple" style="min-width:3em; max-width:3em" :exportable="false" exportFooter=" "></Column>
            <Column field="corpNm" header="Representative" exportFooter=" "></Column>
            <Column field="corpId" header="업체코드" exportFooter=" "></Column>
            <Column field="lineId" header="노선ID" exportFooter=" "></Column>
            <Column field="lineNm" header="노선명" exportFooter=" "></Column>
            <Column field="routeId" header="계통ID" exportFooter=" "></Column>
            <Column field="routeNm" header="계통명" exportFooter=" "></Column>
            <Column field="boardCnt" header="탑승자수" exportFooter=" ">
                <template #body="{ data, field }">
                    <span style="display: inline-block; width: 95%; text-align: right;">{{ formatToNumber(data[field]) }}</span>
                </template>
                <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" mode="decimal" locale="ko-KR" :minFractionDigits="0" inputStyle="text-align: right"/>
                </template>
            </Column>
            <template #groupheader="slotProps">
                <span class="image-text">{{slotProps.data.corpNm}}</span>
            </template>
            <template #groupfooter="slotProps">
                <td style="min-width: 100%">
                    <div style="text-align: right; width: 100%">소계 ({{ calculateTotalCnt(slotProps.data.corpNm) }}건)</div>
                </td>
            </template>
        </DataTable>

        <CodeHelpDialog v-model:search="searchCodeHelp" v-model:selection="selectedCodeHelp" v-model:visible="isCodeHelpDialog" @onComplete="codeHelpComplete" />
    </div>
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from 'primevue/useconfirm';
import CustService from '@/service/ma/CustService';
import MA201080Service from '@/service/ma/MA201080Service';
import JsUtils from '@/utilities/JsUtils';
import CodeHelpDialog from '@/components/CodeHelpDialog';

export default {
    components: {
        'CodeHelpDialog': CodeHelpDialog,
    },
    setup() { 
        onMounted(() => {
            searchParams.compSeq = 1;
            searchParams.status = '5401'; // 거래처상태(사용여부 Y/N)

            // 검색조건에 시작일자,종료일자를 표시한다
            let date = new Date();  
            let fromDate = new Date(date.getFullYear(), date.getMonth(), 1);  // 당월 첫째 일자
            searchParams.fromDate = JsUtils.getDateString(fromDate);            
            searchParams.toDate = JsUtils.getDateString(new Date());          // 현재 일자

            custService.getCodeList(searchParams).then(data => {
                corps.value = data;
            });
        })
        const custService = new CustService();
        const ma201080Service = new MA201080Service();
        const searchParams = reactive({calcYm:null, calcCnt:null, corpId:null});
        const corps = ref([]);
        const dataList = ref([]);
        const selectedItems = ref([]);
        const loading = ref(false);
        const confirm = useConfirm();
        const toast = useToast();

        // 액셀출력
        const dt = ref(); // 데이터 데이블  ref 

        // 코드도움 Dialog
        const isCodeHelpDialog = ref(false);    // 코드도움다이얼로그 표시 여부
        const searchCodeHelp = reactive({helpId:"_calc_cnt", compSeq:1, conds:[{'calcYm':null}]});  // 코드도움 검색조건, 평가차수인 경우 코드도움ID "_calc_cnt", 검색조건 conds:[{'calcYm':null}]에서 calcYm는 평가년도 임 
        const selectedCodeHelp = ref({});       // 코드도움 다이얼로그 검색결과에서 선택된 항목

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "SEARCH":
                        searchList();
                    break;
                case "SAVE":
                    saveList();
                    break; 
                default:
            }
        }

        const btnDialog = (_act, _str) => {
            switch(_act) {
                case 'CodeHelpDialog':
                    // CodeHelpDialog는 공통으로 사용하기 때문에 특정한 Id( ex: calcYm)로 넘기지말고 배열에 담아 넘겨야 한다
                    // 또한, CodeHelpDialog에 넘기는 검색조건도 하나 이상일 수 있다
                    searchCodeHelp.conds[0] = _str;  

                    // CodeHelpDialog를 표시한다
                    isCodeHelpDialog.value = true;

                    // 기존 검색조건을 초기화한다
                    searchParams.calcCnt = null;
                    searchParams.fromDate = null;
                    searchParams.toDate = null;
                    break;
                default:
                    break;
            }
        }
        
        const searchList = () => {
            // 검색조건에서 필수 입력값을 체크한다 - 검색데이터량이 많은 경우(예: 3천건 이상) 필수로 적용할 것!!!    
            if(!JsUtils.checkUndefineColumns(searchParams, ["calcYm", "calcCnt", "corpId"])){
                toast.add({severity:'warn', summary:'필수입력 확인', detail:'평가년도, 평가차수, 업체명 을 선택해주세요.', life:2000});
                return;
            }

            searchParams.fromDate = JsUtils.convertDateToString(searchParams.fromDate);
            searchParams.toDate = JsUtils.convertDateToString(searchParams.toDate);

            loading.value = true;
            ma201080Service.getList(searchParams).then(data => {                 
                if (data.length == 0) toast.add({severity:'warn', summary:'조회 결과', detail:'조회 결과가 없습니다.', life:2000}); 
                dataList.value = data;
            }).finally(() => {
                loading.value = false;
            });
        };

        const saveList = () => {
            confirm.require({
                message:'선택된 항목(들)을 저장하시겠습니까?',
                header: '저장',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    ma201080Service.updateList(selectedItems.value).then(() => {
                        // Datatable에서 선택된 행들을 초기화 한다
                        selectedItems.value = [];
                        searchList();
                        toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                    })
                    .catch(error => {
                        if (error.response) {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.response.data.message, life: 3000});
                        } else if (error.request) {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.request.data, life: 3000});	
                        } else {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.message, life: 3000});	
                        }
                    });
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            });
        };

        // 셀 편집 후, Datatable의 해당 행(Row)를 선택된 상태로 만든다
        const onCellEditComplete = (event) => {
            let { data, newValue, field } = event;
            if(data[field] === newValue) return;

            switch (field) {
                case "boardCnt": { // 탑승자수
                    data[field] = newValue;
                    break;
                }
                default:
                    break;
            }

            // 기존에 추가된 행이 아닌 경우에만 선택된 행 목록에 추가한다
            // 해당 Row를 유일하게 구분할 수 있는 값 사용
            var _ = require('lodash');
            const _row = _.find(selectedItems.value, {'corpId': data.corpId, 'lineId': data.lineId, 'routeId': data.routeId});

            if(_row == null || _row == undefined) {
                selectedItems.value.push(data);
            }
        };

        // 천단위마다 콤마(,) 표시를 한다
        const formatToNumber = (value) => {
            var num = Number(value).toFixed(0);
            return `${Number(num).toLocaleString()}`; // "ko-KR"
        }

        const calculateTotalCnt = (name) => {
            let total = 0;

            if (dataList.value) {
                for (let data of dataList.value) {
                    if (data.corpNm === name) {
                        total++;
                    }
                }
            }

            return total;
        };

        const codeHelpComplete = () => {
            searchParams.calcYm = selectedCodeHelp.value.CALC_YM;
            searchParams.calcCnt = selectedCodeHelp.value.CALC_CNT;
            searchParams.fromDate = selectedCodeHelp.value.CALC_FR_YMD;
            searchParams.toDate = selectedCodeHelp.value.CALC_TO_YMD;
        }

        // 액셀 다운로드
        const downloadExcel = () => {
            // datatable(즉, users.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel(users.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };

        return { 
            dt, searchParams, dataList, corps, selectedItems, loading, 
            calculateTotalCnt, onCellEditComplete, formatToNumber, 
            isCodeHelpDialog, searchCodeHelp, selectedCodeHelp, codeHelpComplete, 
            btnAct, btnDialog, saveList, downloadExcel, exportCSV, 
        }

    }
}
</script>

<style lang="scss" scoped>
.p-rowgroup-footer td {
    font-weight: 700;
}

::v-deep(.p-rowgroup-header) {
    span {
        font-weight: 700;
    }

    .p-row-toggler {
        vertical-align: middle;
        margin-right: .25rem;
    }
}

.table-header {
    display: flex;
    align-items : center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}
b{
    font-size: 30px;
}

.user-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .user-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
